<template>
  <base-editor-page id="builder-outline">
    <template v-slot:description>
      <p>
        Visualize the branches of your content. Any threaded (triggered) emails and instant messages
        will display as a chain. Click on any node shaded in blue to view which email or IM could
        come next.
      </p>
      <p>
        <strong>
          Want to review your emails outside of the platform? Generate a document of all your
          content and print your project.
        </strong>
        <a class="btn btn btn-primary" role="button" :href="stimuliReportLink" target="_blank">
          <span class="fas fa-file-import mr-5" /> Generate
        </a>
      </p>
    </template>
    <outline-chart slot="body"></outline-chart>
  </base-editor-page>
</template>
<script>
  import OutlineChart from './OutlineChart.vue';
  import BaseEditorPage from '@authoringPlatform/shared/BaseEditorPage.vue';
  export default {
    name: 'Outline',

    props: {
      versionKey: {
        type: Number,
        required: true,
      },
    },

    components: {
      OutlineChart,
      BaseEditorPage,
    },

    computed: {
      stimuliReportLink() {
        return `/capsiminbox/authoring-platform/reports/${this.versionKey}/all-content`;
      },
    },
  };
</script>
